import { Link } from "react-router-dom";
import { formatViews, type Movie } from "@/utils/movie";

type MovieCardProps = {
  movie: Movie;
  compact?: boolean;
};

export default function MovieCard({ movie, compact = false }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-accent-300"
    >
      <div className="relative w-full overflow-hidden bg-secondary-200" style={{ aspectRatio: "2 / 3" }}>
        <img
          src={movie.poster}
          alt={`${movie.title} 电影海报`}
          title={`${movie.title} 高清电影在线观看`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-semibold text-background-50">
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-foreground-950/60 px-2 py-0.5 text-xs font-medium text-background-50">
          {movie.year}
        </span>
        {!compact && (
          <div className="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-transparent p-3 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            <p className="line-clamp-3 text-xs leading-relaxed text-background-100">{movie.synopsis}</p>
          </div>
        )}
      </div>
      <div className="flex flex-1 flex-col gap-1.5 p-3">
        <h3 className="line-clamp-2 font-heading text-sm font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-accent-600">
          {movie.title}
        </h3>
        <div className="mt-auto flex flex-wrap items-center gap-1.5">
          {movie.genres.slice(0, 2).map((genre) => (
            <span key={genre} className="rounded-md bg-secondary-100 px-1.5 py-0.5 text-xs text-secondary-900">
              {genre}
            </span>
          ))}
        </div>
        <div className="flex items-center gap-1 text-xs text-foreground-500">
          <i className="ri-fire-line text-accent-500"></i>
          {formatViews(movie.views)} 次观看
        </div>
      </div>
    </Link>
  );
}